import { useState } from 'react';
import { apiFetch } from '../config/api';

export default function SendStaffOnboardingWhatsAppButton({
  token,
  staffId,
  schoolId,
  hasPassword = false,
}) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (hasPassword && !window.confirm('This staff member is already onboarded. Send the onboarding WhatsApp anyway?')) {
      return;
    }

    setSending(true);
    setSent(false);
    setError('');

    try {
      await apiFetch('/whatsapp/staff/send-onboarding', {
        method: 'POST',
        body: JSON.stringify({ staff_id: staffId, school_id: schoolId }),
      }, token);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Could not send staff onboarding WhatsApp.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <button
        type="button"
        className="sa-btn sa-btn-secondary"
        onClick={handleSend}
        disabled={sending || sent || !staffId || !schoolId}
      >
        {sending ? 'Sending...' : sent ? 'WhatsApp Sent' : 'Send Onboarding WhatsApp'}
      </button>
      {error ? <span style={{ color: '#991b1b', fontSize: 12 }}>{error}</span> : null}
    </div>
  );
}
